export default __webpack_public_path__ + "static/media/profile.4639fc89.jpeg";